import {Navigate} from "react-router";
import {useSelector} from "react-redux";
import Cookies from "js-cookie";
import {selectAuthState} from "../store/authSlice";
import GlobalNotificationPopup from "../component/global-fields/GlobalNotificationPopup";
import {persistor, store} from "../store/store";
import dayjs from "dayjs";

export const client = {
  name: "Associated International Brokers, Inc",
  contact: {
    text: "+1 (646) 992-9024",
    link: `tel:+16469929024`,
    chat: "+6469929024",
  },
  email: {
    text: "info@belgiumwebnet.com",
    link: `mailto:info@belgiumwebnet.net`,
  },
  emailSecond: {
    text: "sales@belgiumwebnet.com",
    link: `mailto:sales@belgiumwebnet.net`,
  },
  address: {
    textLine1: "20 W 47th St, Suite 601",
    textLine2: "New York, NY 10036",
    link: "https://www.google.com/maps/dir//20+W+47th+St+%23601,+New+York,+NY+10036,+USA/@40.7570155,-74.0148537,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x89c258fe544d7d25:0xeb7d6ed406a3793e!2m2!1d-73.9798343!2d40.7569558",
  },
};

export const InvoiceAddress = () => {
  // <===---Invoice_Address  //
  return (
    <>
      <h4 className="mb-2">20 W 47th St, Suite 601</h4>
      <h4 className="mb-0"> New York, NY 10036</h4>
    </>
  );
};

export const media_details = [
  // <===---media_details  //
  {
    account_alt: "Facbook",
    // account_icon: <RiFacebookBoxFill />,
    // account_img: Social1,
    account_link: "https://www.facebook.com/belgiumwebnet/",
  },
  {
    account_alt: "Twitter",
    // account_icon: <RiTwitterXFill />,
    // account_img: Social7,
    account_link: "https://twitter.com/belgiumwebnet",
  },
  {
    account_alt: "Instgram",
    // account_icon: <RiInstagramLine />,
    // account_img: Social2,
    account_link: "https://www.instagram.com/belgium_webnet/",
  },
  {
    account_alt: "Linkedin",
    // account_icon: <RiLinkedinBoxFill />,
    // account_img: Social3,
    account_link: "https://www.linkedin.com/company/belgium-webnet/",
  },
];

export const setCookies = (
  key,
  value,
  options = {expires: 14, secure: true}
) => {
  Cookies.set(key, value, options);
};
// setCookie('exampleCookie', 'cookieValue', { expires: 7, secure: true });

export const getCookies = (key) => {
  return Cookies.get(key);
};

// // Get a cookie
// const cookieValue = getCookie('exampleCookie');

export const removeCookies = (key) => {
  Cookies.remove(key);
};
// // Remove a cookie
// removeCookie('exampleCookie');

export const isLogin =
  getCookies("isLogin") && JSON.parse(getCookies("isLogin"))
    ? JSON.parse(getCookies("isLogin"))
    : false;

export const ProtectedRoutes = ({children}) => {
  let {user} = useSelector(selectAuthState);
  return user?.id ? children : <Navigate to="/" />;
};

export const AuthenticatedRoute = ({children}) => {
  let {user} = useSelector(selectAuthState);
  // console.log("AuthenticatedRoute", isLogin, user, children);
  return user?.id ? children : <Navigate to="/login" />;
};

// Private Route Component
export const PrivateRoute = ({children}) => {
  const isAuthenticated = !!localStorage.getItem("authToken");
  return isAuthenticated ? children : <Navigate to="/login" />;
};

export const StrictRoute = ({children}) => {
  const isStrictlyAuthorized = !!localStorage.getItem("strictAuthToken"); // Example for stricter access
  return isStrictlyAuthorized ? children : <Navigate to="/dashboard" />;
};

export const RestrictedRoute = ({children}) => {
  let {user} = useSelector(selectAuthState);
  // console.log("RestrictedRoute", isLogin, children);
  return user?.id ? <Navigate to="/dashboard" /> : children;
};

export const handleLogout = () => {
  GlobalNotificationPopup({type: "success", message: "logged out."});
  store.dispatch({type: "LOGOUT"});
  persistor.purge();
  removeCookies("isLogin");
  return;
};

export const formatOrAddNumberStrings = (
  numberString1,
  numberString2 = null
) => {
  // Helper function to convert input (string or number) to a float
  function toNumber(input) {
    if (typeof input === "string") {
      return parseFloat(input.replace(/,/g, ""));
    }
    return parseFloat(input); // If it's already a number, return it as-is
  }

  // Helper function to format a number to two decimal places with commas
  function formatNumber(number) {
    return number.toLocaleString("en-US", {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });
  }

  // If only one input is passed, format it
  if (numberString2 === null) {
    const number = toNumber(numberString1);
    return formatNumber(number);
  }

  // If two inputs are passed, add them
  const number1 = toNumber(numberString1);
  const number2 = toNumber(numberString2);
  const total = number1 + number2;

  // Format and return the result
  return formatNumber(total);
};

export const USD_FORMATTEROOLD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
});

export const parseToNumberOLD = (value) => {
  // Remove non-numeric and non-decimal values
  const parsedValue = value.replace(/[^0-9.]/g, "");

  // Handle empty string case to avoid NaN
  if (parsedValue === "" || isNaN(Number(parsedValue))) {
    return "";
  }

  return parseFloat(parsedValue);
};

export const USD_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const parseToNumber = (value) => {
  if (!value) return "";

  // Remove everything except digits and one decimal point
  let cleaned = value.replace(/[^0-9.]/g, "");

  // Prevent multiple dots
  const parts = cleaned.split(".");
  if (parts.length > 2) {
    cleaned = parts[0] + "." + parts.slice(1).join("");
  }

  // Handle just "." or empty gracefully
  if (cleaned === "." || cleaned === "") return "";

  const num = parseFloat(cleaned);
  return isNaN(num) ? "" : num;
};

export const parseToNumberVersion2 = (value) => {
  if (typeof value === "string") {
    const cleaned = value.replace(/[^0-9.-]+/g, "");
    return cleaned ? parseFloat(cleaned) : 0;
  }
  return value ?? 0;
};
export const parseToNumberVersion3 = (value) => {
  if (typeof value === "string") {
    const cleaned = value.replace(/[^0-9.-]+/g, "");
    return cleaned ? parseFloat(cleaned) : "";
  }
  return value ?? "";
};

export const handleFileUploadWithoutVids = ({
  event,
  fieldName,
  formik,
  maxSizeMB = 1,
  onError,
  allowedTypes,
}) => {
  const file = event.target.files[0];
  if (!file) return;

  // Default allowed types: images and common docs (no video)
  const defaultAllowedTypes = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/plain",
  ];

  const validTypes = allowedTypes || defaultAllowedTypes;

  const isValidType = validTypes.includes(file.type);
  const isValidSize = file.size <= maxSizeMB * 1024 * 1024;

  if (!isValidType) {
    onError("Unsupported file type. Only images/documents are allowed.");
    return;
  }

  if (!isValidSize) {
    onError(`File size should not exceed ${maxSizeMB} MB.`);
    return;
  }

  formik.setFieldValue(fieldName, file);
};

export const toSentenceCase = (str = "") => {
  const lower = str.toLowerCase();
  return lower.replace(/^./, (match) => match.toUpperCase());
};

export const toCapitalCase = (str = "") => {
  if (!str) return null;
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

// export const isStrictValidDate = (
//   dateInput,
//   { minYear = 1900, maxYear = 2100 } = {}
// ) => {
//   const parsedDate =
//     typeof dateInput === "string"
//       ? dayjs(dateInput, ["MM/DD/YYYY", "YYYY-MM-DD"], true)
//       : dayjs(dateInput);

//   return (
//     parsedDate.isValid() &&
//     parsedDate.year() >= minYear &&
//     parsedDate.year() <= maxYear
//   );
// };
export const isStrictValidDate = (
  dateInput,
  minYear = 1900,
  maxYear = 2100
) => {
  const parsedDate =
    typeof dateInput === "string"
      ? dayjs(dateInput, ["MM/DD/YYYY", "YYYY-MM-DD"], true)
      : dayjs(dateInput);
  return (
    parsedDate.isValid() &&
    parsedDate.year() >= minYear &&
    parsedDate.year() <= maxYear
  );
};

export const hasEmptyField = (obj) => {
  if (typeof obj === "string") {
    return obj.trim() === "";
  }

  if (Array.isArray(obj)) {
    return obj.some((item) => hasEmptyField(item));
  }

  if (typeof obj === "object" && obj !== null) {
    return Object.values(obj).some((value) => hasEmptyField(value));
  }

  return false;
};

export const areRequiredFieldsFilled = (formik) => {
  try {
    formik?.validationSchema?.validateSync(formik?.values, {abortEarly: false});
    return true;
  } catch (error) {
    console.error(
      "Validation failed for fields:",
      error?.inner?.map((e) => ({
        path: e.path,
        message: e.message,
      }))
    );
    return false;
  }
};

export const normalizeCurrencyToNumberOLD = (value) => {
  // Return null if input is empty or null/undefined
  if (value == null || value === "") return null;

  if (typeof value === "string") {
    // Remove non-numeric characters except dot and minus
    const cleaned = value.replace(/[^0-9.-]+/g, "");
    const parsed = parseFloat(cleaned);
    // If parsing fails, treat as 0
    return isNaN(parsed) ? 0 : parsed;
  }

  // If value is a number, return it
  return typeof value === "number" ? value : 0;
};

export const normalizeCurrencyToNumber = (value) => {
  // Return null if input is empty, null, or undefined
  if (value == null || value === "") return null;

  if (typeof value === "string") {
    // Remove everything except digits, one dot, and optional minus
    let cleaned = value.replace(/[^0-9.-]/g, "");

    // Handle multiple dots by keeping the first one only
    const parts = cleaned.split(".");
    if (parts.length > 2) {
      cleaned = parts[0] + "." + parts.slice(1).join("");
    }

    // Handle just "-" or "." gracefully
    if (cleaned === "-" || cleaned === "." || cleaned === "-.") return 0;

    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  }

  // If value is already a number, return it
  return typeof value === "number" ? value : 0;
};

export const initialFormValidationsOLD = [
  {s1: 0},
  {s2: 0},
  {s3: 0},
  {s4: 0},
  {s5: 0},
  {s6: 0},
  {s7: 0},
  {s8: 0},
  {s9: 0},
  {s10: 0},
  {s11: 0},
  {s12: 0},
]; // 0-Neutral, 1-Validated, 2-Invalid

export const initialFormValidations = [
  {
    step: 1,
    status: 0,
  },
  {
    step: 2,
    status: 0,
  },
  {
    step: 3,
    status: 0,
  },
  {
    step: 4,
    status: 0,
  },
  {
    step: 5,
    status: 0,
  },
  {
    step: 6,
    status: 0,
  },
  {
    step: 7,
    status: 0,
  },
  {
    step: 8,
    status: 0,
  },
  {
    step: 9,
    status: 0,
  },
  {
    step: 10,
    status: 0,
  },
  {
    step: 11,
    status: 0,
  },
  {
    step: 12,
    status: 0,
  },
];
